// extracted by mini-css-extract-plugin
export default {"wrap":"nJ-z","articleImagesWrap":"oJ-z","articleImage":"pJ-z","singleImage":"qJ-z"};